<template>
  <div class="withdraw-page">
    <div class="page-header">
      <div class="page-title">提现</div>
      <el-button plain size="small" @click="goBack">返回分销权益</el-button>
    </div>

    <!-- 顶部统计与操作区 -->
    <div class="stats-section">
      <div class="stats-row">
        <div class="stat-item">
          <div class="stat-label">账户总额（元）</div>
          <div class="stat-value">{{ stats.totalBalance }}</div>
        </div>
        <div class="stat-item">
          <div class="stat-label">可提现总额（元）</div>
          <div class="stat-value">{{ stats.availableBalance }}</div>
        </div>
        <div class="stat-item">
          <div class="stat-label">提现中</div>
          <div class="stat-value highlight">{{ stats.withdrawingAmount }}</div>
        </div>
        <div class="action-item">
          <el-button type="primary" class="withdraw-btn" @click="showWithdrawDialog = true">提现</el-button>
        </div>
      </div>
    </div>

    <!-- 提现记录列表 -->
    <div class="records-section">
      <div class="section-header-row">
        <div class="section-title">提现记录</div>
        <div class="filter-area">
          <el-select v-model="query.status" placeholder="全部状态" size="small" @change="handleFilterChange" clearable>
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="已通过" :value="1"></el-option>
            <el-option label="已拒绝" :value="2"></el-option>
          </el-select>
        </div>
      </div>
      
      <el-table :data="records" v-loading="loading" style="width: 100%" class="records-table">
        <el-table-column prop="createTime" label="申请时间" min-width="160"></el-table-column>
        <el-table-column label="提现金额" min-width="120">
          <template slot-scope="scope">
            <span class="amount-text">{{ scope.row.amount }}元</span>
          </template>
        </el-table-column>
        <el-table-column label="提现账户" min-width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.bankName }}</div>
            <div class="bank-account">{{ scope.row.bankAccount }}</div>
            <div class="account-name">{{ scope.row.accountName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="small">
              {{ scope.row.statusText }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip></el-table-column>
      </el-table>

      <div class="pagination-container" v-if="total > 0">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="query.pageNum"
          :page-size="query.pageSize"
          @current-change="fetchRecords"
        />
      </div>
    </div>

    <!-- 提现弹框  -->
    <el-dialog
      title="佣金提现"
      :visible.sync="showWithdrawDialog"
      width="500px"
      custom-class="withdraw-dialog"
      :show-close="true"
      center
      append-to-body
    >
      <div class="withdraw-content">
        <div class="available-amount">
          <div class="amount-value">{{ stats.availableBalance }}</div>
          <div class="amount-label">可提现金额</div>
        </div>
        <div class="withdraw-form-container">
          <el-form :model="withdrawForm" ref="withdrawForm" label-width="70px" label-position="left" size="medium">
             <el-form-item label="姓名" required>
               <el-input v-model="withdrawForm.accountName" placeholder="请输入开户人姓名"></el-input>
             </el-form-item>
             <el-form-item label="银行" required>
               <el-input v-model="withdrawForm.bankName" placeholder="请输入银行名称"></el-input>
             </el-form-item>
             <el-form-item label="卡号" required>
               <el-input v-model="withdrawForm.bankAccount" placeholder="请输入银行卡号"></el-input>
             </el-form-item>
             <el-form-item label="金额" required>
               <el-input v-model="withdrawForm.amount" placeholder="最低提现500元" type="number">
                 <template slot="append">元</template>
               </el-input>
             </el-form-item>
             <el-form-item label="备注">
               <el-input v-model="withdrawForm.remark" placeholder="选填" type="textarea" :rows="2"></el-input>
             </el-form-item>
          </el-form>
        </div>
        <div class="withdraw-actions">
          <el-button type="primary" class="confirm-withdraw-btn" @click="confirmWithdraw" :loading="loading">立即提现</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getWithdrawRecords, getWithdrawStatistics, applyWithdraw } from '@/api/authApi'

export default {
  name: 'AppWithdraw',
  data() {
    return {
      showWithdrawDialog: false,
      withdrawForm: {
        accountName: '',
        bankName: '',
        bankAccount: '',
        amount: '',
        remark: ''
      },
      loading: false,
      records: [],
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 10,
        status: undefined
      },
      stats: {
        totalBalance: 0,
        availableBalance: 0,
        withdrawingAmount: 0
      }
    }
  },
  mounted() {
    this.fetchRecords()
    this.fetchStats()
  },
  methods: {
    goBack() {
      this.$router.push('/member-center/distribution-rights')
    },
    async fetchStats() {
      try {
        const res = await getWithdrawStatistics()
        const data = res.data || {}
        this.stats = {
          totalBalance: Number(data.totalBalance) || 0,
          availableBalance: Number(data.availableBalance) || 0,
          withdrawingAmount: Number(data.withdrawingAmount) || 0
        }
      } catch (err) {
        console.error('Failed to fetch stats', err)
      }
    },
    async confirmWithdraw() {
      const { accountName, bankName, bankAccount, amount } = this.withdrawForm
      if (!accountName || !bankName || !bankAccount || !amount) {
        this.$message.warning('请填写完整的提现信息')
        return
      }
      const val = Number(amount)
      if (val < 500) {
        this.$message.warning('最低提现金额为500元')
        return
      }
      if (val > this.stats.availableBalance) {
        this.$message.warning('提现金额不能超过可提现余额')
        return
      }
      
      this.loading = true
      try {
        await applyWithdraw({
          accountName,
          bankName,
          bankAccount,
          amount: val,
          remark: this.withdrawForm.remark
        })
        this.$message.success('提现申请提交成功')
        this.showWithdrawDialog = false
        // 重置表单
        this.withdrawForm = {
          accountName: '',
          bankName: '',
          bankAccount: '',
          amount: '',
          remark: ''
        }
        // 刷新数据
        this.fetchStats()
        this.handleFilterChange() // 刷新列表到第一页
      } catch (err) {
        this.$message.error((err && err.message) || '提现申请失败')
      } finally {
        this.loading = false
      }
    },
    async fetchRecords() {
      this.loading = true
      try {
        const res = await getWithdrawRecords(this.query)
        const data = res.data || {}
        this.records = data.list || []
        this.total = Number(data.total) || 0
      } catch (err) {
        this.$message.error((err && err.message) || '获取提现记录失败')
        this.records = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleFilterChange() {
      this.query.pageNum = 1
      this.fetchRecords()
    },
    getStatusType(status) {
      // 0：待审核，1：已通过，2：已拒绝
      const map = {
        0: 'warning',
        1: 'success',
        2: 'danger'
      }
      return map[status] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.withdraw-page {
  padding: 20px;
  background-color: #fff;
  min-height: 100%;

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    
    .page-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }

  .stats-section {
    padding-bottom: 30px;
    border-bottom: 1px solid #eee;
    margin-bottom: 30px;

    .stats-row {
      display: flex;
      align-items: center;
      
      .stat-item {
        flex: 1;
        
        .stat-label {
          font-size: 14px;
          color: #333;
          margin-bottom: 12px;
        }
        
        .stat-value {
          font-size: 18px;
          color: #333;
          font-weight: 500;
          
          &.highlight {
            color: #ff4d4f;
          }
        }
      }
      
      .action-item {
        .withdraw-btn {
          background-color: #4034eb;
          border-color: #4034eb;
          padding: 10px 30px;
          border-radius: 4px;
          font-size: 14px;
          
          &:hover {
            background-color: #554af0;
            border-color: #554af0;
          }
        }
      }
    }
  }

  .records-section {
    .section-header-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .section-title {
        font-size: 20px;
        font-weight: 600;
        color: #3E2CCD;
        margin-bottom: 0;
      }
    }

    .records-table {
      margin-bottom: 20px;
      
      .amount-text {
        color: #ff4d4f;
        font-weight: 500;
      }
      
      .bank-account {
        font-size: 12px;
        color: #999;
      }
      
      .account-name {
        font-size: 12px;
        color: #666;
      }
    }

    .pagination-container {
      text-align: right;
      padding-top: 10px;
    }
  }
}

// 提现弹框样式 (复用)
.withdraw-content {
  text-align: center;
  padding: 10px 20px 30px;

  .available-amount {
    margin-bottom: 40px;

    .amount-value {
      font-size: 40px;
      font-weight: 500;
      color: #d93025;
      margin-bottom: 12px;
      font-family: Arial, sans-serif;
    }

    .amount-label {
      color: #999;
      font-size: 14px;
    }
  }

  .withdraw-form-container {
    margin-bottom: 20px;
    text-align: left;
    padding: 0 10px;

    ::v-deep .el-form-item {
      margin-bottom: 22px;
      
      .el-form-item__label {
        color: #666;
        font-weight: normal;
        padding-right: 12px;
      }
      
      .el-form-item__content {
        line-height: 40px;
      }
    }

    ::v-deep .el-input__inner {
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      
      &:focus {
        border-color: #4034eb;
      }
    }
    
    ::v-deep .el-input-group__append {
      background-color: #f5f7fa;
      border-color: #dcdfe6;
      color: #909399;
      padding: 0 15px;
    }
    
    ::v-deep .el-textarea__inner {
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      font-family: inherit;
      padding: 8px 15px;
      
      &:focus {
        border-color: #4034eb;
      }
    }
  }
  
  .withdraw-actions {
    .confirm-withdraw-btn {
      width: 100%;
      height: 54px;
      background-color: #4034eb;
      border-color: #4034eb;
      border-radius: 8px;
      font-size: 18px;
      font-weight: 500;
      
      &:hover {
        background-color: #554af0;
        border-color: #554af0;
      }
    }
  }
}

::v-deep .withdraw-dialog {
  border-radius: 12px;
  
  .el-dialog__header {
    padding-top: 30px;
    .el-dialog__title {
      font-size: 20px;
      font-weight: bold;
      color: #333;
    }
  }
  
  .el-dialog__body {
    padding: 10px 30px 30px;
  }
}
</style>
